import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import Card from "../card";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // Import the default styles

const PopupMessage = ({ message, onClose }) => (
  <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    <div className="bg-white p-5 rounded shadow-lg">
      <p>{message}</p>
      <div className="text-center">
        <button
          onClick={onClose}
          className="bg-[#ffffff] cursor-pointer hover:bg-[#234971] hover:text-white text-[#234971] border-2  text-[18px] rounded-[40px] font-medium h-[40px] md:h-[50px] w-[168px] mt-5  transition-all duration-300"
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

function Home({ section1Ref }) {
  // const [value, setValue] = useState("");

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  // console.log(baseUrl, "baseurl");
  AOS.init();
  // const doctorExperience = "url('/assets/drbg.jpeg')";

  // doctor

  const backgroundImage = "url('./assets/herocard.png')";
  const [acceptTerms, setAcceptTerms] = useState(false);

  // const [isloading, setIsloading] = useState(true);

  // useEffect(() => {
  //   const fakeDatafetch = () => {
  //     setTimeout(() => {
  //       setIsloading(false);
  //     }, 2000);
  //   };
  //   fakeDatafetch();
  // }, []);

  const reviews = [
    {
      text: "I recently had several tests done at Aqua Medical Laboratories, and I’m very pleased with the results. The staff was professional and compassionate, and I felt well taken care of. However, I felt that the pricing could have been more transparent. Overall, the service was solid and I received valuable insights into my health.",
      rating: 5,
      name: "Rachel Green",
    },
    {
      text: "Aqua Medical Laboratories was fantastic! The medical tests were comprehensive and the results came back quickly. The staff was friendly, and I felt confident in their expertise. It's reassuring to have a lab that truly cares about my health and well-being.",
      rating: 5,
      name: "James Hall",
    },
    {
      text: "I’ve used Aqua Medical Laboratories for multiple tests, and they have been very professional throughout. The only downside was the wait time for appointment availability, but once I got in, the service was excellent. I would definitely recommend them to others.",
      rating: 4,
      name: "Ella White",
    },
    {
      text: "Aqua Medical helped me with comprehensive diagnostic testing. The results were clear, and the staff provided excellent follow-up care. However, the cost was higher than I expected compared to other labs. Still, I felt the results and the level of service were worth the price.",
      rating: 5,
      name: "Chris Martin",
    },
    {
      text: "I had a great experience at Aqua Medical Laboratories. The testing process was fast and efficient, and the lab staff explained everything in detail. The results were delivered on time, and I appreciated the clarity and thoroughness of the reports. I highly recommend their services.",
      rating: 5,
      name: "Olivia Carter",
    },
    {
      text: "Aqua Medical Laboratories did a thorough job with my diagnostic tests, but I was disappointed by the lack of follow-up after receiving my results. While the information I received was helpful, I would have appreciated more support in understanding and interpreting the results.",
      rating: 5,
      name: "Daniel Harris",
    },
  ];

  const [startIndex, setStartIndex] = useState(0);

  const nextReview = () => {
    if (startIndex + 3 < reviews.length) {
      setStartIndex(startIndex + 3);
    }
  };

  const prevReview = () => {
    if (startIndex - 3 >= 0) {
      setStartIndex(startIndex - 3);
    }
  };

  const visibleReviews = reviews.slice(startIndex, startIndex + 3);

  // blog
  // const backgroundWaves = "url('/assets/waves.png')";

  const [blog, setBlog] = useState([]);
  const [doctorData, setDoctorData] = useState([]);
  const [teamData, setTeamData] = useState([]);

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${baseUrl}/blog/blogs`);
      if (response.status === 200) {
        const data = await response.json();
        setBlog(data);
      } else {
        throw new Error("Unable to fetch data");
      }
    } catch (err) {
      console.error(err);
      setBlog([]);
    }
  };
  const fetchDoctorData = async () => {
    try {
      const response = await fetch(`${baseUrl}/home/getdoctors`);
      if (response.status === 200) {
        const data = await response.json();
        // console.log("Fetched DOC data:", data);
        setDoctorData(data);
      } else {
        throw new Error("Unable to fetch data");
      }
    } catch (err) {
      console.error(err);
    }
  };
  const fetchItems = async () => {
    try {
      const response = await fetch(`${baseUrl}/home/getallteam`);
      if (response.status === 200) {
        const data = await response.json();
        // console.log("Fetched DOC data:", data);
        setTeamData(data);
      } else {
        throw new Error("Unable to fetch data");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await Promise.all([fetchBlogs(), fetchDoctorData(), fetchItems()]);
    };

    loadData();
  }, []);

  // const truncateText = (text, wordLimit) => {
  //   if (!text) return "";
  //   const words = text.split(" ");
  //   if (words.length <= wordLimit) return text;
  //   return words.slice(0, wordLimit).join(" ") + "...";
  // };

  // contact
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    gender: "",
    dob: "",
    inquiryType: "",
    appointmentType: "",
    preferredDateTime: "",
    servicesphlebo: "",
    servicewellness: "",
    description: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handlePhoneNumberChange = (phoneNumber) => {
    setFormData({ ...formData, phoneNumber });
  };

  const handleDateChange = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = date.getHours() % 12 || 12;
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const amPm = date.getHours() >= 12 ? "PM" : "AM";

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${amPm}`;

    setFormData((prevState) => ({
      ...prevState,
      preferredDateTime: formattedDateTime,
    }));
  };

  const handleDateChange1 = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    setFormData((prevState) => ({
      ...prevState,
      dob: formattedDate,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let dataToSend = formData;

    if (formData.appointmentType === "Phlebotomy Appointment" && !acceptTerms) {
      setErrorMessage("Please tick the checkbox to proceed with Home Service.");
      return;
    }
    if (formData.inquiryType === "General Inquiry") {
      dataToSend = {
        title: formData.title,
        firstName: formData.firstName,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        gender: formData.gender,
        dob: formData.dob,
        inquiryType: formData.inquiryType,
        description: formData.description,
      };
    }

    try {
      const response = await axios.post(
        `${baseUrl}/contact/submit`,
        dataToSend,
      );

      setShowPopup(true);
      setErrorMessage("");

      setFormData({
        title: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        gender: "",
        dob: "",
        inquiryType: "",
        appointmentType: "",
        preferredDateTime: "",
        servicesphlebo: "",
        description: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrorMessage("Error submitting form. Please try again.");
    }
  };

  useEffect(() => {
    if (window.location.hash === "#contact") {
      const contactElement = document.getElementById("contact");
      if (contactElement) {
        const offset = -800;
        const elementPosition =
          contactElement.getBoundingClientRect().top +
          window.pageYOffset -
          offset;

        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    }
  }, []);

  // const [selectedDOB, setSelectedDOB] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  return (
    <>
      <div className="overflow-hidden h-auto relative">
        <div
          id="blog"
          className="lg:px-[calc((100%-1280px)/2)]  md:h-[100vh]  px-2 relative flex flex-col z-0 py-10 "
          style={{
            backgroundImage: "url(/assets/hero.jpeg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <p className="text-[#234971] tracking-[1px] lg:text-[28px] md:text-[22px] text-[18px] font-[600] text-center mb-4">
            BLOGS
          </p>

          <div className="flex flex-wrap xl:justify-between lg:mt-20 justify-center items-center w-full lg:gap-6 gap-4">
            {blog.slice(0, 3).map((item, index) => (
              <Card
                key={index}
                image={item.img}
                title={item.title}
                link={item.link}
                id={item.blogId}
              />
            ))}
          </div>
          <div className="h-full w-full absolute top-0 left-0 -z-10"></div>

          <div className="flex justify-center relative z-10 mys-4 mt-20">
            <Link to="./blog">
              <button className="flex items-center text-[14px] lg:text-[18px] justify-between md:pr-2 pr-1 md:pl-4 pl-3 md:w-[150px] lg:w-[160px] md:h-[45px] xl:h-[55px] h-[40px] w-[115px] bg-[#234971] text-[#ffffff] hover:bg-[#ffffff] hover:text-[#234971] border-[2px] hover:border-[#234971] transition-all duration-300 rounded-[40px] font-[500]">
                View More
                <img
                  src="./assets/hero/more.png"
                  alt=""
                  className="bg-[#234971] h-[20px] md:h-[35px] rounded-full md:p-2 p-1"
                />
              </button>
            </Link>
          </div>
        </div>

        {/* page 4 */}
        <div
          id="ourteam"
          className="relative  w-full flex items-center justify-center py-5"
        >
          <div className="lg:px-[calc((100%-1280px)/2)] h-full w-full">
            <div className="flex justify-center">
              <p className="text-[#234971] tracking-[1px] lg:text-[28px] md:text-[22px] text-[18px] font-[600] text-center mb-4">
                OUR TEAM
              </p>
            </div>
            <div className="text-black relative bg-cover xl:justify-between justify-centers overflow-x-auto flex gap-5 px-3  xl:px-0 scroll-container">
              <div className="flex xl:flex-wrap xl:justify-between w-full gap-10 snap-x snap-mandatory">
                {teamData.slice(0, 3).map((item, index) => (
                  <div
                    key={index}
                    className="group lg:w-[320px] my-5 overflow-hidden  lg:h-[400px] w-[280px] h-[380px] rounded-[25px] relative snap-center flex-shrink-0"
                    data-aos="flip-right"
                    data-aos-duration="2000"
                    style={{
                      backgroundImage: backgroundImage,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <div className="flex justify-center h-[80%] ">
                      <img
                        src={item.img}
                        alt=""
                        className="h-[100%] group-hover:w-[40%] w-[100%] transition-all duration-700 group-hover:h-[40%] group-hover:mt-5 group-hover:rounded-b-[25px] cover rounded-t-[25px]"
                      />
                    </div>

                    <div className="hidden lg:block absolute w-full text-white group-hover:lg:bottom-[100px] lg:-bottom-[75px] group-hover  transition-all duration-1000">
                      <p className="md:text-[20px] text-[18px] font-[600] lg:py-1 text-center w-full">
                        {item.name}
                      </p>
                      <p className="text-center px-5 md:text-[16px] text-[14px] mt-2 md:mt-5">
                        {item.position}
                      </p>
                      <div className="flex mt-5 items-center justify-center flex-col">
                        <div className="flex justify-center relative z-10">
                          <Link
                            to={`/ourteam/${encodeURIComponent(item.name)}?id=${item.id}`}
                          >
                            <button className="flex items-center text-[10px] md:text-[12px] justify-between pr-1 pl-1 lg:w-[100px] h-[30px] w-[100px] bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]">
                              Read More
                              <img
                                src="./assets/hero/more.png"
                                alt=""
                                className="bg-[#234971] lg:h-[20px] h-[20px] rounded-full   p-1"
                              />
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className=" block lg:hidden absolute w-full text-white group-hover:bottom-[100px] lg:bottom-[75px] transition-all duration-1000">
                      <p className="md:text-[20px] text-[18px] font-[600] text-center w-full">
                        {item.name}
                      </p>
                      <p className="text-center px-5 md:text-[16px] text-[14px] mt-2 md:mt-5">
                        {item.position}
                      </p>
                      <div className="flex mt-5 items-center justify-center flex-col">
                        <div className="flex justify-center relative z-10">
                          <Link
                            to={`/ourteam/${encodeURIComponent(item.name)}?id=${item.id}`}
                          >
                            <button className="flex items-center text-[10px] md:text-[12px] justify-between pr-1 pl-1 lg:w-[100px] h-[30px] w-[100px] bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]">
                              Read More
                              <img
                                src="./assets/hero/more.png"
                                alt=""
                                className="bg-[#234971] lg:h-[20px] h-[20px] rounded-full p-1"
                              />
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-center relative z-10 mt-10">
              <Link to="/ourTeam">
                <button className="flex items-center text-[14px] lg:text-[18px] justify-between md:pr-2 pr-1 md:pl-4 pl-3 md:w-[150px] lg:w-[160px] md:h-[45px] xl:h-[55px] h-[40px] w-[115px] bg-[#234971] text-[#ffffff] hover:bg-[#ffffff] hover:text-[#234971] border-[2px] hover:border-[#234971] transition-all duration-300 rounded-[40px] font-[500]">
                  View More
                  <img
                    src="./assets/hero/more.png"
                    alt=""
                    className="bg-[#234971] h-[20px] md:h-[35px] rounded-full md:p-2 p-1"
                  />
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* page 5 */}

        <div
          id="doctor"
          className="relative min-h-[85vh] w-full flex mt-10 items-center justify-center py-5 px-3 xl:px-0"
        >
          <div className="lg:px-[calc((100%-1280px)/2)] h-full w-full relative z-10">
            <div className="flex justify-center">
              <p className="text-[#234971] tracking-[1px] lg:text-[28px] md:text-[22px] text-[18px] font-[600] text-center mb-6">
                OUR EXPERIENCED DOCTORS
              </p>
            </div>

            <div className="text-black relative bg-cover xl:justify-between justify-centers overflow-x-auto flex gap-5 px-3  xl:px-0 scroll-container">
              <div className="flex xl:flex-wrap xl:justify-between w-full gap-10 snap-x snap-mandatory">
                {doctorData.map((item, index) => (
                  <>
                    <div
                      key={index}
                      className="group lg:w-[320px] my-5 overflow-hidden  lg:h-[400px] w-[280px] h-[380px] rounded-[25px] relative snap-center flex-shrink-0"
                      data-aos="flip-right"
                      data-aos-duration="2000"
                      style={{
                        backgroundImage: backgroundImage,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="flex justify-center h-[80%] ">
                        <img
                          src={item.img}
                          alt=""
                          className="h-[100%] group-hover:w-[40%] w-[100%] transition-all duration-700 group-hover:h-[40%] group-hover:mt-5 group-hover:rounded-b-[25px] cover rounded-t-[25px]"
                        />
                      </div>

                      <div className="hidden lg:block absolute w-full text-white group-hover:lg:bottom-[40px] lg:-bottom-[145px] bottom-[100px] group-hover  transition-all duration-1000">
                        <p className="md:text-[20px] text-[18px] font-[600] lg:py-1 text-center w-full">
                          {item.name}
                        </p>
                        <p className="h-[100px] text-center px-5 md:text-[16px] text-[14px] mt-2 md:mt-5">
                          {item.description}
                        </p>
                        <div className="flex mt-5 items-center justify-center flex-col">
                          <div className="flex justify-center relative z-10">
                            <Link
                              to={`/doctors/${encodeURIComponent(item.name)}?id=${item.id}`}
                            >
                              <button className="flex items-center text-[10px] md:text-[12px] justify-between pr-1 pl-1 lg:w-[100px] h-[30px] w-[100px] bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]">
                                Read More
                                <img
                                  src="./assets/hero/more.png"
                                  alt=""
                                  className="bg-[#234971] lg:h-[20px] h-[20px] rounded-full   p-1"
                                />
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className=" block lg:hidden absolute w-full h-[200px] text-white group-hover:bottom-[30px] lg: -bottom-[155px] transition-all duration-1000">
                        <p className="md:text-[20px] text-[18px] font-[600] text-center w-full">
                          {item.name}
                        </p>
                        <p className="text-center px-5 md:text-[16px] text-[14px] mt-5 md:mt-5">
                          {item.description}
                        </p>
                        <div className="flex mt-5 items-center justify-center flex-col">
                          <div className="flex justify-center relative z-10">
                            <Link to={`./doctorProfile?id=${item.id}`}>
                              <button className="flex items-center text-[10px] md:text-[12px] justify-between pr-1 pl-1 lg:w-[100px] h-[30px] w-[100px] bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]">
                                Read More
                                <img
                                  src="./assets/hero/more.png"
                                  alt=""
                                  className="bg-[#234971] lg:h-[20px] h-[20px] rounded-full p-1"
                                />
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="flex justify-center relative z-10 mt-10">
              <Link to="/doctors">
                <button className="flex items-center text-[14px] lg:text-[18px] justify-between md:pr-2 pr-1 md:pl-4 pl-3 md:w-[150px] lg:w-[160px] md:h-[45px] xl:h-[55px] h-[40px] w-[115px] bg-[#234971] text-[#ffffff] hover:bg-[#ffffff] hover:text-[#234971] border-[2px] hover:border-[#234971] transition-all duration-300 rounded-[40px] font-[500]">
                  View More
                  <img
                    src="./assets/hero/more.png"
                    alt=""
                    className="bg-[#234971] h-[20px] md:h-[35px] rounded-full md:p-2 p-1"
                  />
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div id="contact" ref={section1Ref} className="relative my-5 lg:mt-16 ">
          <div className="">
            <p className="text-[#234971] tracking-[1px] lg:text-[28px] md:text-[22px] text-[18px] font-[600] text-center mb-4">
              GET IN TOUCH
            </p>
            <p
              className="text-[#888888] text-[18px] px-2 font-[400] flex justify-center"
              data-aos="fade-down"
              data-aos-duration="2000"
            >
              We’d love to hear from you. Please fill out this form.
            </p>
            <div className="grid grid-cols-1 xl:grid-cols-2 mt-10 lg:px-[calc((100%-1320px)/2)] lg:gap-2 relative z-10">
              <div
                className="px-5 text-justify"
                data-aos="fade-down-right"
                data-aos-duration="2000"
              >
                <p className="md:text-[16px] text-[14px] font-medium text-[#234971]">
                  "Need assistance? We're just a message away. Reach out
                  anytime, and we'll be happy to help. Your convenience is our
                  priority. Contact us with any questions or concerns."
                </p>

                <div className="mt-2 xl:mt-10 flex gap-4 items-center">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask id="path-1-inside-1_46_802" fill="white">
                      <path d="M15.3117 10.5234L11.6211 8.86945C11.4539 8.7978 11.2714 8.769 11.0903 8.78564C10.9091 8.80228 10.735 8.86385 10.5836 8.96477C10.5682 8.97463 10.5536 8.98559 10.5399 8.99758L8.61095 10.6382C8.59093 10.6491 8.56865 10.6552 8.54587 10.656C8.52309 10.6568 8.50044 10.6523 8.4797 10.6429C7.23985 10.0445 5.95548 8.76789 5.3547 7.54524C5.34469 7.52481 5.33949 7.50236 5.33949 7.47961C5.33949 7.45686 5.34469 7.43442 5.3547 7.41399L7.00079 5.46086C7.0126 5.44641 7.02356 5.43128 7.0336 5.41555C7.13312 5.2636 7.19324 5.08926 7.20851 4.90826C7.22379 4.72726 7.19375 4.54531 7.1211 4.37883L5.47892 0.694454C5.38566 0.476961 5.22437 0.295581 5.01927 0.177536C4.81418 0.0594911 4.57632 0.0111495 4.34142 0.0397664C3.3205 0.173982 2.38338 0.675343 1.70518 1.45016C1.02699 2.22497 0.654119 3.22022 0.656259 4.24992C0.656259 10.3671 5.63282 15.3437 11.75 15.3437C12.7797 15.3456 13.7748 14.9727 14.5496 14.2946C15.3244 13.6164 15.8258 12.6794 15.9602 11.6585C15.9887 11.4247 15.941 11.1879 15.8242 10.9834C15.7074 10.7789 15.5276 10.6175 15.3117 10.5234ZM11.75 14.4062C6.15001 14.4062 1.59376 9.84992 1.59376 4.24992C1.59115 3.4483 1.88048 2.67316 2.4077 2.06931C2.93492 1.46545 3.66396 1.07421 4.4586 0.968673H4.47657C4.50805 0.96926 4.53863 0.979347 4.56428 0.997609C4.58993 1.01587 4.60946 1.04146 4.62032 1.07102L6.26876 4.75148C6.27816 4.77195 6.28303 4.7942 6.28303 4.81672C6.28303 4.83924 6.27816 4.86149 6.26876 4.88195L4.61954 6.83977C4.60724 6.85374 4.59601 6.86863 4.58595 6.8843C4.48275 7.04184 4.42198 7.22337 4.40952 7.41129C4.39707 7.59921 4.43335 7.78717 4.51485 7.95695C5.20782 9.3757 6.63751 10.7945 8.07188 11.4874C8.24266 11.5685 8.43153 11.6039 8.62007 11.5902C8.80862 11.5765 8.99039 11.5142 9.14767 11.4093C9.16251 11.3991 9.17735 11.3882 9.19141 11.3765L11.1195 9.73586C11.1386 9.72563 11.1596 9.71963 11.1812 9.71828C11.2028 9.71694 11.2244 9.72027 11.2445 9.72805L14.9359 11.382C14.9661 11.3948 14.9915 11.4168 15.0084 11.4448C15.0254 11.4729 15.0331 11.5055 15.0305 11.5382C14.9255 12.3332 14.5346 13.0628 13.9309 13.5906C13.3272 14.1184 12.5519 14.4083 11.75 14.4062Z" />
                    </mask>
                    <path
                      d="M15.3117 10.5234L11.6211 8.86945C11.4539 8.7978 11.2714 8.769 11.0903 8.78564C10.9091 8.80228 10.735 8.86385 10.5836 8.96477C10.5682 8.97463 10.5536 8.98559 10.5399 8.99758L8.61095 10.6382C8.59093 10.6491 8.56865 10.6552 8.54587 10.656C8.52309 10.6568 8.50044 10.6523 8.4797 10.6429C7.23985 10.0445 5.95548 8.76789 5.3547 7.54524C5.34469 7.52481 5.33949 7.50236 5.33949 7.47961C5.33949 7.45686 5.34469 7.43442 5.3547 7.41399L7.00079 5.46086C7.0126 5.44641 7.02356 5.43128 7.0336 5.41555C7.13312 5.2636 7.19324 5.08926 7.20851 4.90826C7.22379 4.72726 7.19375 4.54531 7.1211 4.37883L5.47892 0.694454C5.38566 0.476961 5.22437 0.295581 5.01927 0.177536C4.81418 0.0594911 4.57632 0.0111495 4.34142 0.0397664C3.3205 0.173982 2.38338 0.675343 1.70518 1.45016C1.02699 2.22497 0.654119 3.22022 0.656259 4.24992C0.656259 10.3671 5.63282 15.3437 11.75 15.3437C12.7797 15.3456 13.7748 14.9727 14.5496 14.2946C15.3244 13.6164 15.8258 12.6794 15.9602 11.6585C15.9887 11.4247 15.941 11.1879 15.8242 10.9834C15.7074 10.7789 15.5276 10.6175 15.3117 10.5234ZM11.75 14.4062C6.15001 14.4062 1.59376 9.84992 1.59376 4.24992C1.59115 3.4483 1.88048 2.67316 2.4077 2.06931C2.93492 1.46545 3.66396 1.07421 4.4586 0.968673H4.47657C4.50805 0.96926 4.53863 0.979347 4.56428 0.997609C4.58993 1.01587 4.60946 1.04146 4.62032 1.07102L6.26876 4.75148C6.27816 4.77195 6.28303 4.7942 6.28303 4.81672C6.28303 4.83924 6.27816 4.86149 6.26876 4.88195L4.61954 6.83977C4.60724 6.85374 4.59601 6.86863 4.58595 6.8843C4.48275 7.04184 4.42198 7.22337 4.40952 7.41129C4.39707 7.59921 4.43335 7.78717 4.51485 7.95695C5.20782 9.3757 6.63751 10.7945 8.07188 11.4874C8.24266 11.5685 8.43153 11.6039 8.62007 11.5902C8.80862 11.5765 8.99039 11.5142 9.14767 11.4093C9.16251 11.3991 9.17735 11.3882 9.19141 11.3765L11.1195 9.73586C11.1386 9.72563 11.1596 9.71963 11.1812 9.71828C11.2028 9.71694 11.2244 9.72027 11.2445 9.72805L14.9359 11.382C14.9661 11.3948 14.9915 11.4168 15.0084 11.4448C15.0254 11.4729 15.0331 11.5055 15.0305 11.5382C14.9255 12.3332 14.5346 13.0628 13.9309 13.5906C13.3272 14.1184 12.5519 14.4083 11.75 14.4062Z"
                      fill="#234971"
                    />
                  </svg>

                  <p className="text-[#234971] font-semibold md:text-[16px] text-[14px]">
                    +442038797131
                  </p>
                </div>

                <div className="mt-2 flex gap-4 items-center">
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.33332 13.6666C1.87499 13.6666 1.48277 13.5035 1.15666 13.1774C0.830545 12.8513 0.667212 12.4588 0.666656 11.9999V1.99992C0.666656 1.54159 0.82999 1.14936 1.15666 0.823252C1.48332 0.497141 1.87555 0.333808 2.33332 0.333252H15.6667C16.125 0.333252 16.5175 0.496585 16.8442 0.823252C17.1708 1.14992 17.3339 1.54214 17.3333 1.99992V11.9999C17.3333 12.4583 17.1703 12.8508 16.8442 13.1774C16.518 13.5041 16.1255 13.6671 15.6667 13.6666H2.33332ZM8.99999 7.83325L2.33332 3.66659V11.9999H15.6667V3.66659L8.99999 7.83325ZM8.99999 6.16658L15.6667 1.99992H2.33332L8.99999 6.16658ZM2.33332 3.66659V1.99992V11.9999V3.66659Z"
                      fill="#234971"
                    />
                  </svg>

                  <p className="text-[#234971] font-semibold md:text-[16px] text-[14px]">
                    info@aquamedlabs.com
                  </p>
                </div>

                <div className="mt-2 flex gap-4 items-center">
                  <svg
                    width="16"
                    height="22"
                    viewBox="0 0 16 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 20.1886L8.72114 19.376C9.53942 18.4389 10.2754 17.5497 10.9303 16.704L11.4709 15.9909C13.728 12.9497 14.8571 10.536 14.8571 8.75203C14.8571 4.94403 11.7874 1.85718 8 1.85718C4.21257 1.85718 1.14285 4.94403 1.14285 8.75203C1.14285 10.536 2.272 12.9497 4.52914 15.9909L5.06971 16.704C6.00393 17.9011 6.98133 19.0626 8 20.1886Z"
                      stroke="#234971"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 11.5715C9.57795 11.5715 10.8571 10.2923 10.8571 8.71432C10.8571 7.13636 9.57795 5.85718 8 5.85718C6.42204 5.85718 5.14285 7.13636 5.14285 8.71432C5.14285 10.2923 6.42204 11.5715 8 11.5715Z"
                      stroke="#234971"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <p className="text-[#234971] font-semibold md:text-[16px] text-[14px] w-[280px]">
                    Aqua Medical Laboratories LTD, 300 Kensal Road, North
                    Kensington, W10 5BE
                  </p>
                </div>
                <div className="pt-2  ">
                  <p className="text-[#234971] font-bold ml-8 md:text-[16px] text-[14px] w-[280px]">
                    Office Working Hours:
                  </p>
                  <div className="flex gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#234971"
                    >
                      <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" />
                    </svg>
                    <p className="text-[#234971] font-semibold md:text-[16px] text-[14px] w-[280px]">
                      Monday - Friday(9AM - 6PM)
                    </p>
                  </div>
                </div>
                <div className="relative  mt-4 w-[80%] h-[35%] aspect-[16/9]">
                  <iframe
                    title="map-location"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9929.093576508902!2d-0.2113797!3d51.5265452!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876118dba5b7b0f%3A0xb59bead03ab72fe1!2sAqua%20Medical%20Laboratories%20LTD!5e0!3m2!1sen!2sin!4v1729254539939!5m2!1sen!2sin"
                    className="absolute top-0 left-0 w-full h-full rounded-2xl"
                    loading="lazy"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              <div
                className="lg:px-2 px-2 mt-2 md:mt-0 md:mb-0 "
                data-aos="fade-down-left"
                data-aos-duration="2000"
              >
                <div className=" md:mt-0">
                  <div
                    className="bg-white px-4 py-4  rounded-lg shadow-lg w-full"
                    style={{
                      backgroundImage: backgroundImage,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <form
                      onSubmit={handleSubmit}
                      className="space-y-4 text-[14px]"
                    >
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-[18px] font-[500]">
                        <select
                          value={formData.title}
                          onChange={handleChange}
                          name="title"
                          placeholder="Title"
                          id="title"
                          className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        >
                          <option value="" disabled>
                            Title*
                          </option>
                          <option value="Mr.">Mr.</option>
                          <option value="Mrs.">Mrs.</option>
                          <option value="Miss.">Miss.</option>
                          <option value="Dr.">Dr.</option>
                        </select>
                        <input
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          placeholder="First Name"
                          className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        />
                        <input
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          placeholder="Last Name"
                          className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        />

                        <div className="inputboxDatehome h-[40px] px-2 md:h-[50px] rounded-[6px] z-20">
                          <PhoneInput
                            defaultCountry="GB"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handlePhoneNumberChange}
                            placeholder="Phone Number*"
                            className="w-full h-[40px] md:h-[50px]  outline-none mb-2 text-[#234971] block border-1  "
                            international
                            withCountryCallingCode
                          />
                        </div>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email"
                          className="w-full h-[40px] mt-2 md:mt-0 md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        />
                        <select
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                          className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        >
                          <option value="" className="">
                            Select Gender
                          </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>

                        <div className="inputboxDatehome h-[40px] md:h-[50px] rounded-[6px] z-20 mb-4">
                          <DatePicker
                            name="dob"
                            selected={
                              formData.dob
                                ? new Date(
                                    formData.dob.split("-").reverse().join("-"),
                                  )
                                : null
                            }
                            onChange={handleDateChange1}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="DOB (dd-mm-yyyy)"
                            className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                          />
                        </div>

                        <select
                          name="inquiryType"
                          value={formData.inquiryType}
                          onChange={handleChange}
                          className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        >
                          <option value="">Select Inquiry Type</option>
                          <option value="General Inquiry">
                            General Inquiry
                          </option>
                          <option value="Appointment Scheduling">
                            Appointment Scheduling
                          </option>
                        </select>
                      </div>

                      {formData.inquiryType === "Appointment Scheduling" && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <select
                            name="appointmentType"
                            value={formData.appointmentType}
                            onChange={handleChange}
                            className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                            required
                          >
                            <option value="">Select Appointment Type</option>
                            <option value="Doctor Appointment">
                              Doctor Appointment
                            </option>
                            <option value="Phlebotomy Appointment">
                              Phlebotomy Appointment
                            </option>
                            <option value="Health Coach Appointment">
                              Health Coach Appointment
                            </option>

                            <option value="Wellness Clinic">
                              Wellness Clinic Appointment
                            </option>
                          </select>

                          <div className="inputboxDatehome h-[40px] md:h-[50px] rounded-[6px] z-20">
                            <div className="!w-full">
                              <DatePicker
                                name="preferredDateTime"
                                value={formData.preferredDateTime}
                                selected={selectedTime}
                                onChange={handleDateChange}
                                showTimeSelect
                                timeIntervals={15}
                                timeFormat="h:mm aa"
                                dateFormat="dd-MM-yyyy h:mm aa"
                                className="custom-datepicker !w-[280px] h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                                placeholderText="Preferred Date & Time"
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={50}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {formData.appointmentType === "Phlebotomy Appointment" &&
                        formData.inquiryType === "Appointment Scheduling" && (
                          <select
                            name="servicesphlebo"
                            value={formData.servicesphlebo}
                            onChange={handleChange}
                            className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                            required
                          >
                            <option value="">Select Service Type</option>
                            <option value="Lab Service Phlebotomy Appointment">
                              Lab Service Phlebotomy Appointment
                            </option>
                            <option value="Home Care Phlebotomy Appointment">
                              Home Service Phlebotomy Appointment
                            </option>
                          </select>
                        )}

                      {formData.appointmentType === "Wellness Clinic" && (
                        <select
                          name="servicewellness"
                          value={formData.servicewellness}
                          onChange={handleChange}
                          className="w-full h-[40px] md:h-[50px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                          required
                        >
                          <option value="">Select Service Type</option>
                          <option value="Advanced Aesthetic Treatments">
                            Advanced Aesthetic Treatment Service{" "}
                          </option>
                          <option value="Functional Laboratory Testing">
                            Functional Laboratory Testing Service
                          </option>
                          <option value="IV Nutritional Therapy at Aqua Wellness Clinic">
                            IV Nutritional Therapy at Aqua Wellness Service
                          </option>
                        </select>
                      )}

                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Description"
                        className="w-full h-[100px] text-[18px] font-[500] text-[#234971] outline-none block indent-5 rounded-[5px] pt-2"
                        required
                      />

                      {formData.appointmentType ===
                        "Phlebotomy Appointment" && (
                        <div className="flex items-center mt-2">
                          <input
                            type="checkbox"
                            id="acceptTerms"
                            checked={acceptTerms}
                            onChange={() => setAcceptTerms(!acceptTerms)}
                            className="h-5 w-5 text-[#234971] border-[#234971] focus:ring-[#234971]"
                            required
                          />
                          <label
                            htmlFor="acceptTerms"
                            className="ml-2 text-[#ffff] text-[13px] cursor-pointer"
                          >
                            Please be aware that home service comes with extra
                            charges, while lab services are free.
                          </label>
                        </div>
                      )}
                      <div className="flex justify-center">
                        <button
                          type="submit"
                          className="bg-[#ffffff] cursor-pointer hover:bg-[#234971] hover:text-white text-[#234971] border-2 text-[24px] rounded-[40px] font-medium h-[40px] md:h-[60px] w-[168px] mt-4 flex justify-center items-center transition-all duration-300"
                        >
                          Send
                        </button>
                      </div>
                    </form>

                    {errorMessage && (
                      <p className="error-message">{errorMessage}</p>
                    )}
                    {showPopup && (
                      <PopupMessage
                        message="Successfully sent! The appropriate team will contact you."
                        onClose={() => setShowPopup(false)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* review  */}

        <div className="lg:px-[calc((100%-1280px)/2)] mt-5 lg:mt-10 mb-10">
          <p className="text-[#234971] tracking-[1px] lg:text-[28px] md:text-[22px] text-[18px] font-[600] text-center mb-4">
            WHAT PEOPLE THINK ABOUT US
          </p>

          {/* Reviews container */}
          <div className="flex flex-wrap justify-center gap-10">
            {visibleReviews.map((review, index) => (
              <div
                key={index}
                className="border-[#A3D284] border-[2px] rounded-[20px] lg:w-[360px] lg:h-[260px] w-[280px] p-4 cursor-pointer
              md:w-[45%] sm:w-[90%] xl:w-[30%]"
              >
                <p className="text-[12px] md:text-[14px] lg:text-[14px]">
                  {review.text}
                </p>
                <div className="flex items-center gap-2 md:mt-3 mt-1">
                  {[...Array(5)].map((_, i) => {
                    if (i < Math.floor(review.rating)) {
                      return (
                        <svg
                          key={`full-${i}`}
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="#A3D284"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" />
                        </svg>
                      );
                    } else if (
                      i === Math.floor(review.rating) &&
                      review.rating % 1 >= 0.5
                    ) {
                      return (
                        <svg
                          key={`half-${i}`}
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill="#A3D284" // Green for the filled part of the star
                            d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z"
                          />

                          <path
                            fill="white"
                            d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z"
                            transform="scale(0.5, 1)" // This shrinks the second path for the empty part of the star to show the half-fill
                            transform-origin="center" // Keeps the scaling centered in the star
                          />
                        </svg>
                      );
                    } else {
                      // Empty stars (outline with green stroke)
                      return (
                        <svg
                          key={`empty-${i}`}
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z"
                            stroke="#A3D284"
                            strokeWidth="2"
                          />
                        </svg>
                      );
                    }
                  })}

                  <p className="font-[600] md:text-[16px] text-[14px]">
                    {review.rating}
                  </p>
                </div>
                <p className="text-[#202020] font-[600] md:text-[16px] text-[14px] mt-2">
                  {review.name}
                </p>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={prevReview}
              className="text-2xl cursor-pointer text-[#234971] p-2"
              disabled={startIndex === 0}
            >
              &lt; {/* Previous button */}
            </button>
            <button
              onClick={nextReview}
              className="text-2xl cursor-pointer text-[#234971] p-2"
              disabled={startIndex + 3 >= reviews.length}
            >
              &gt; {/* Next button */}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
